import { supabase } from './supabaseClient';

export const fetchNews = async () => {
    const { data, error } = await supabase
        .from('news')
        .select('*')
        .order('created_at', { ascending: false });
    
    if (error) {
        console.error('Error fetching news:', error);
        return [];
    }
    return data;
};

export const createNews = async (newsData) => {
    const { data, error } = await supabase
        .from('news')
        .insert([newsData])
        .select();
    
    if (error) {
        console.error('Error creating news:', error);
        throw error;
    }
    return data[0];
};

export const updateNews = async (id, newsData) => {
    const { data, error } = await supabase
        .from('news')
        .update(newsData)
        .eq('id', id)
        .select();
    
    if (error) {
        console.error('Error updating news:', error);
        throw error;
    }
    return data[0];
};

export const deleteNews = async (id) => {
    const { error } = await supabase
        .from('news')
        .delete()
        .eq('id', id);
    
    if (error) {
        console.error('Error deleting news:', error);
        throw error;
    }
};
